import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import {PageTop, TitleH1, Title, SidebarNews, InfoBlock, Main, Content, Row, Col2 } from '../layouts/layouts'
import SideBarRight from '../layouts/SideBarRight'
import Gallery from '../layouts/gallery'

import thumb1 from '../assets/nettiterapia-140x140-5226.jpg'
import img1 from '../assets/nettiterapia.jpg'
import net from '../assets/nettiterapia2-310x345-7197.jpg'

class Psykoterapia extends React.Component {

  render() {
    return (
      <div>
        <Helmet>
          <title>Kirsti Louko - Nettiterapia</title>
        </Helmet>
        <Content>
          <SideBarRight view="net"/>
          <Main column>
            <Title>NETTITERAPIA</Title>
            <p>Nettiterapia on verkossa tehtävää terapiaa, jossa vuorovaikutus tapahtuu sähköpostiviestin, chatin, skypen tai puhelun kautta. Tärkeä hyöty on riippumattomuus ajasta ja paikasta.</p>
            <p>Nettiterapia ja puhelinterapia toimivat ja ovat matalan kynnyksen terapiaa.</p>
            <p>Tutkimusten mukaan nettiterapia on yhtä tuloksellista kuin perinteinen psykoterapia. Hyvä terapeuttinen suhde mahdollistuu yhtä lailla nettiterapiassa (Skype tai sähköposti) tai puhelimen välityksellä. (Hanley & Reynolds 2009.)</p>
            <p>Palvelun käytöstä aiheutuvat kustannukset (puhelin- tai internet-yhteyden kulut ja muut maksut) ovat asiakkaan vastuulla. Ensimmäinen kysely on maksuton.</p>
            <p>Ota yhteyttä ja kysy lisää:  &nbsp;<Link to="/yhteystiedot">yhteydenottolomake</Link></p>
            <Row>
              <Col2>
                <img src={net} style={{margin: ' 0 auto'}}/>

              </Col2>
              <Col2>
                <Gallery
                  images={[
                    { src: `${img1}`,
                      thumb: `${thumb1}`,
                    },

                  ]}
                />
              </Col2>

            </Row>
          </Main>
        </Content>

      </div>
    )
  }
}

export default Psykoterapia;



// WEBPACK FOOTER //
// ./src/pages/nettiterapia.js